import { Grid } from '@app/components/ui-kit/Grid';
import { MyLink } from '@ui-kit/Link';
import IconAkit from './akit.svg';

import styles from './PartnersBlock.module.scss';

export const PartnersBlock = (): JSX.Element => {
  return (
    <Grid className={styles.Container}>
      <MyLink href="/akit/" target={'_blank'}>
        <IconAkit width={43} height={45} data-testid="footer-akit" />
      </MyLink>
    </Grid>
  );
};
